/** What installed plugins contribute, and running one of their buttons. See PluginButtons. */

import { useQuery } from '@tanstack/react-query'
import { BookOpen, Bug, FlaskConical, Gauge, Play, Puzzle, Rocket, ShieldCheck, Sparkles, Wrench, type LucideIcon } from 'lucide-react'
import { api } from './api'
import type { PluginCommand, PluginItem } from './types'

export const PLUGIN_ICONS: Record<string, LucideIcon> = {
  play: Play, sparkles: Sparkles, shield: ShieldCheck, flask: FlaskConical, rocket: Rocket,
  gauge: Gauge, bug: Bug, book: BookOpen, wrench: Wrench, puzzle: Puzzle,
}

export function usePluginCommands(placement: PluginCommand['placement']) {
  const { data } = useQuery({ queryKey: ['plugins'], queryFn: api.plugins.list, staleTime: 60_000, retry: false })
  return (data ?? [])
    .filter((plugin) => plugin.installed)
    .flatMap((plugin) => plugin.commands.filter((c) => c.placement === placement).map((command) => ({ plugin, command })))
}

export function runPluginCommand(plugin: PluginItem, command: PluginCommand, repositoryId: string | null) {
  return api.workOrders.create({
    kind: command.kind,
    instructions: command.prompt,
    title: `${plugin.name}: ${command.title}`,
    repositoryId,
    maxIterations: command.kind === 'UntilDone' ? 5 : null,
  })
}
